import { useState } from "react";
import { useQuery } from "@tanstack/react-query";

import { financePaymentRequestQueryKey } from "../config";
import { searchFinancePrepaymentSettlementSuppliers } from "../repo/financePaymentRequestRepo";
import type { FinancePrepaymentSupplierOption } from "../types";

/**
 * 给其他结算主体发起预付款时选结算主体：按关键字在能当结算主体的供应商里搜（不做防抖，关键字进 queryKey）；
 * 选中的记下名字，换关键字搜后仍按名字显示。
 */
export function useFinancePrepaymentSupplierPicker() {
  const [keyword, setKeyword] = useState("");
  const [picked, setPicked] = useState<FinancePrepaymentSupplierOption | null>(null);
  const trimmed = keyword.trim();
  const query = useQuery({
    queryKey: [...financePaymentRequestQueryKey, "settlement-suppliers", trimmed],
    queryFn: () => searchFinancePrepaymentSettlementSuppliers(trimmed),
    retry: false,
    refetchOnWindowFocus: false,
  });
  const found = query.data ?? [];
  const options = picked && !found.some((item) => item.supplierId === picked.supplierId) ? [picked, ...found] : found;
  return {
    options,
    loading: query.isFetching,
    failed: query.isError,
    picked,
    /** 输入关键字搜。 */
    search: setKeyword,
    /** 选中一个结算主体。 */
    pick(supplierId: string) {
      setPicked(options.find((item) => item.supplierId === supplierId) ?? null);
    },
  };
}
